import React, { useState } from 'react';
import './Page2.css';
import './Page2-resources.css';

const STATE_NAMES = {
  AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California',
  CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', FL: 'Florida', GA: 'Georgia',
  HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa',
  KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland',
  MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi', MO: 'Missouri',
  MT: 'Montana', NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey',
  NM: 'New Mexico', NY: 'New York', NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio',
  OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina',
  SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont',
  VA: 'Virginia', WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming'
};

function getOrdinal(n) {
  const num = parseInt(n);
  if (isNaN(num)) return n;
  const s = ['th', 'st', 'nd', 'rd'];
  const v = num % 100;
  return num + (s[(v - 20) % 10] || s[v] || s[0]);
}

// ── YOUR STATE ELECTION RESOURCES — official state election pages (Lisa's verified list, Oct 2026) ──
const STATE_ELECTION_SITES = {
  AK: 'https://www.elections.alaska.gov/',
  AL: 'https://www.sos.alabama.gov/alabama-votes',
  AR: 'https://www.sos.arkansas.gov/elections',
  AZ: 'https://azsos.gov/elections',
  CA: 'https://www.sos.ca.gov/elections',
  CO: 'https://www.sos.state.co.us/pubs/elections/main.html',
  CT: 'https://portal.ct.gov/sots/common-elements/v5-template---redesign/elections--voting--home-page',
  DE: 'https://elections.delaware.gov/',
  FL: 'https://dos.myflorida.com/elections/',
  GA: 'https://sos.ga.gov/index.php/elections',
  HI: 'https://elections.hawaii.gov/',
  IA: 'https://sos.iowa.gov/elections-voting',
  ID: 'https://sos.idaho.gov/elections-division/',
  IL: 'https://www.elections.il.gov/',
  IN: 'https://www.in.gov/sos/elections/',
  KS: 'https://www.sos.ks.gov/elections/elections.html',
  KY: 'https://elect.ky.gov/',
  LA: 'https://www.sos.la.gov/elections-voting',
  MA: 'https://www.sec.state.ma.us/ele/eleidx.htm',
  MD: 'https://voterservices.elections.maryland.gov/PollingPlaceSearch',
  ME: 'https://www.maine.gov/sos/elections-voting',
  MI: 'https://www.michigan.gov/sos/elections',
  MN: 'https://www.sos.state.mn.us/elections-voting/',
  MO: 'https://www.sos.mo.gov/elections/',
  MS: 'https://www.sos.ms.gov/index.php/elections-voting',
  MT: 'https://sosmt.gov/elections/',
  NC: 'https://www.ncsbe.gov/',
  ND: 'https://sos.nd.gov/elections',
  NE: 'https://sos.nebraska.gov/elections/general-voter-information',
  NH: 'https://www.sos.nh.gov/elections/voters',
  NJ: 'https://www.nj.gov/state/elections/',
  NM: 'https://www.sos.nm.gov/voting-and-elections/',
  NV: 'https://www.nvsos.gov/sos/elections',
  NY: 'https://www.elections.ny.gov/',
  OH: 'https://www.ohiosos.gov/elections',
  OK: 'https://oklahoma.gov/elections.html',
  OR: 'https://sos.oregon.gov/voting-elections/Pages/default.aspx',
  PA: 'https://www.pa.gov/agencies/vote',
  RI: 'https://vote.sos.ri.gov/',
  SC: 'https://www.scvotes.gov/',
  SD: 'https://sdsos.gov/elections-voting/default.aspx',
  TN: 'https://sos.tn.gov/elections',
  TX: 'https://www.sos.state.tx.us/elections/index.shtml',
  UT: 'https://vote.utah.gov/',
  VA: 'https://www.elections.virginia.gov/',
  VT: 'https://sos.vermont.gov/elections/',
  WA: 'https://www.sos.wa.gov/elections/',
  WI: 'https://myvote.wi.gov/en-us/',
  WV: 'https://sos.wv.gov/elections/Pages/default.aspx',
  WY: 'https://sos.wyo.gov/Elections/Default.aspx',
};

// ── 2026 GOVERNOR — from Lisa's Excel (unchanged from original Page 2) ──
const GOVERNOR_NO_2026 = {
  DE: { name: 'Matt Meyer',      party: 'Democratic', nextElection: 'November 2028' },
  IN: { name: 'Mike Braun',      party: 'Republican', nextElection: 'November 2028' },
  KY: { name: 'Andy Beshear',    party: 'Democratic', nextElection: 'November 2027' },
  LA: { name: 'Jeff Landry',     party: 'Republican', nextElection: 'October 2027' },
  MS: { name: 'Tate Reeves',     party: 'Republican', nextElection: 'November 2027' },
  MO: { name: 'Mike Kehoe',      party: 'Republican', nextElection: 'November 2028' },
  MT: { name: 'Greg Gianforte',  party: 'Republican', nextElection: 'November 2028' },
  NJ: { name: 'Mikie Sherrill',  party: 'Democratic', nextElection: 'November 2029' },
  NC: { name: 'Josh Stein',      party: 'Democratic', nextElection: 'November 2028' },
  ND: { name: 'Kelly Armstrong', party: 'Republican', nextElection: 'November 2028' },
  UT: { name: 'Spencer Cox',     party: 'Republican', nextElection: 'November 2028' },
  VA: { name: 'Abigail Spanberger', party: 'Democratic', nextElection: 'November 2029' },
  WA: { name: 'Bob Ferguson',    party: 'Democratic', nextElection: 'November 2028' },
  WV: { name: 'Patrick Morrisey', party: 'Republican', nextElection: 'November 2028' },
};

// ── 2026 U.S. SENATE — from Lisa's Excel (unchanged from original Page 2) ──
const SENATE_NO_2026 = {
  AZ: { senators: [{ name: 'Ruben Gallego', party: 'Democratic' }, { name: 'Mark Kelly', party: 'Democratic' }], nextElection: '2028 / 2030' },
  CA: { senators: [{ name: 'Adam Schiff', party: 'Democratic' }, { name: 'Alex Padilla', party: 'Democratic' }], nextElection: '2028 / 2030' },
  CT: { senators: [{ name: 'Richard Blumenthal', party: 'Democratic' }, { name: 'Chris Murphy', party: 'Democratic' }], nextElection: '2028 / 2030' },
  FL: { senators: [{ name: 'Ashley Moody', party: 'Republican' }, { name: 'Rick Scott', party: 'Republican' }], nextElection: '2028 / 2030' },
  HI: { senators: [{ name: 'Mazie Hirono', party: 'Democratic' }, { name: 'Brian Schatz', party: 'Democratic' }], nextElection: '2028 / 2030' },
  IN: { senators: [{ name: 'Jim Banks', party: 'Republican' }, { name: 'Todd Young', party: 'Republican' }], nextElection: '2028 / 2030' },
  MO: { senators: [{ name: 'Josh Hawley', party: 'Republican' }, { name: 'Eric Schmitt', party: 'Republican' }], nextElection: '2028 / 2030' },
  NV: { senators: [{ name: 'Catherine Cortez Masto', party: 'Democratic' }, { name: 'Jacky Rosen', party: 'Democratic' }], nextElection: '2028 / 2030' },
  NY: { senators: [{ name: 'Chuck Schumer', party: 'Democratic' }, { name: 'Kirsten Gillibrand', party: 'Democratic' }], nextElection: '2028 / 2030' },
  ND: { senators: [{ name: 'John Hoeven', party: 'Republican' }, { name: 'Kevin Cramer', party: 'Republican' }], nextElection: '2028 / 2030' },
  PA: { senators: [{ name: 'John Fetterman', party: 'Democratic' }, { name: 'Dave McCormick', party: 'Republican' }], nextElection: '2028 / 2030' },
  UT: { senators: [{ name: 'Mike Lee', party: 'Republican' }, { name: 'John Curtis', party: 'Republican' }], nextElection: '2028 / 2030' },
  VT: { senators: [{ name: 'Bernie Sanders', party: 'Independent' }, { name: 'Peter Welch', party: 'Democratic' }], nextElection: '2028 / 2030' },
  WA: { senators: [{ name: 'Patty Murray', party: 'Democratic' }, { name: 'Maria Cantwell', party: 'Democratic' }], nextElection: '2028 / 2030' },
  WI: { senators: [{ name: 'Ron Johnson', party: 'Republican' }, { name: 'Tammy Baldwin', party: 'Democratic' }], nextElection: '2028 / 2030' },
};

// ── 2026 LIEUTENANT GOVERNOR ELECTIONS (31 states have elections in 2026) ──
// Source: Ballotpedia. States NOT in this list either don't hold 2026 LtGov elections
// or don't have the office at all.
const LTGOV_ELECTIONS_2026 = new Set([
  'AL','AK','AZ','AR','CA','CO','CT','FL','GA','HI','ID','IL','IA','KS','MD','MA',
  'MI','MN','NE','NV','NM','NY','OH','OK','PA','RI','SC','SD','TX','VT','WI'
]);
// States that HAVE a Lt Governor but no 2026 election, with incumbent info
const LTGOV_NO_2026 = {
  DE: { name: 'Kyle Evans Gay',      party: 'Democratic', nextElection: 'November 2028' },
  IN: { name: 'Micah Beckwith',      party: 'Republican', nextElection: 'November 2028' },
  KY: { name: 'Jacqueline Coleman',  party: 'Democratic', nextElection: 'November 2027' },
  LA: { name: 'Billy Nungesser',     party: 'Republican', nextElection: 'October 2027' },
  MS: { name: 'Delbert Hosemann',    party: 'Republican', nextElection: 'November 2027' },
  MO: { name: 'David Wasinger',      party: 'Republican', nextElection: 'November 2028' },
  MT: { name: 'Kristen Juras',       party: 'Republican', nextElection: 'November 2028' },
  NJ: { name: 'Tahesha Way',         party: 'Democratic', nextElection: 'November 2029' },
  NC: { name: 'Rachel Hunt',         party: 'Democratic', nextElection: 'November 2028' },
  ND: { name: 'Michelle Strinden',   party: 'Republican', nextElection: 'November 2028' },
  UT: { name: 'Deidre Henderson',    party: 'Republican', nextElection: 'November 2028' },
  VA: { name: 'Ghazala Hashmi',      party: 'Democratic', nextElection: 'November 2029' },
  WA: { name: 'Denny Heck',          party: 'Democratic', nextElection: 'November 2028' },
  WV: { name: 'Randy Smith',         party: 'Republican', nextElection: 'November 2028' },
};
// States that don't have a Lieutenant Governor at all
const LTGOV_NO_OFFICE = new Set(['ME','NH','OR','TN','WY']);

// ── 2026 ATTORNEY GENERAL ELECTIONS (30 states) ──
const AG_ELECTIONS_2026 = new Set([
  'AL','AZ','AR','CA','CO','CT','DE','FL','GA','ID','IL','IA','KS','MD','MA','MI',
  'MN','NE','NV','NM','NY','ND','OH','OK','RI','SC','SD','TX','VT','WI'
]);
const AG_NO_2026 = {
  IN: { name: 'Todd Rokita',      party: 'Republican', nextElection: 'November 2028' },
  KY: { name: 'Russell Coleman',  party: 'Republican', nextElection: 'November 2027' },
  LA: { name: 'Liz Murrill',      party: 'Republican', nextElection: 'October 2027' },
  MS: { name: 'Lynn Fitch',       party: 'Republican', nextElection: 'November 2027' },
  MO: { name: 'Andrew Bailey',    party: 'Republican', nextElection: 'November 2028' },
  MT: { name: 'Austin Knudsen',   party: 'Republican', nextElection: 'November 2028' },
  NC: { name: 'Jeff Jackson',     party: 'Democratic', nextElection: 'November 2028' },
  OR: { name: 'Dan Rayfield',     party: 'Democratic', nextElection: 'November 2028' },
  PA: { name: 'Dave Sunday',      party: 'Republican', nextElection: 'November 2028' },
  TN: { name: 'Jonathan Skrmetti', party: 'Republican', nextElection: 'Appointed' },
  UT: { name: 'Derek Brown',      party: 'Republican', nextElection: 'November 2028' },
  VA: { name: 'Jason Miyares',    party: 'Republican', nextElection: 'November 2029' },
  WA: { name: 'Nick Brown',       party: 'Democratic', nextElection: 'November 2028' },
  WV: { name: 'JB McCuskey',      party: 'Republican', nextElection: 'November 2028' },
};
// States where the AG is not elected by voters
const AG_NOT_ELECTED = new Set(['AK','HI','NH','NJ','WY','ME']);

// ── 2026 STATE TREASURER ELECTIONS (25 states) ──
const TREASURER_ELECTIONS_2026 = new Set([
  'AL','AZ','AR','CA','CO','DE','FL','ID','IL','IN','IA','KS','MA','NE','NV','NM',
  'OH','OK','PA','RI','SC','SD','VT','WI','WY','CT'
]);
const TREASURER_NO_2026 = {
  KY: { name: 'Mark Metcalf',     party: 'Republican', nextElection: 'November 2027' },
  LA: { name: 'John Fleming',     party: 'Republican', nextElection: 'October 2027' },
  MS: { name: 'David McRae',      party: 'Republican', nextElection: 'November 2027' },
  MO: { name: 'Vivek Malek',      party: 'Republican', nextElection: 'November 2028' },
  NC: { name: 'Brad Briner',      party: 'Republican', nextElection: 'November 2028' },
  ND: { name: 'Thomas Beadle',    party: 'Republican', nextElection: 'November 2028' },
  OR: { name: 'Elizabeth Steiner', party: 'Democratic', nextElection: 'November 2028' },
  UT: { name: 'Marlo Oaks',       party: 'Republican', nextElection: 'November 2028' },
  VA: { name: 'Ellen Coleman',    party: '—',          nextElection: 'Appointed' },
  WA: { name: 'Mike Pellicciotti', party: 'Democratic', nextElection: 'November 2028' },
  WV: { name: 'Larry Pack',       party: 'Republican', nextElection: 'November 2028' },
};
// States without an elected state treasurer role (varies — some have an appointed equivalent)
const TREASURER_NO_OFFICE = new Set(['AK','HI','MI','MN','MT','NH','NJ','NY','TN','TX','MD','GA']);

// ── 2026 SECRETARY OF STATE ELECTIONS (26 states) ──
const SOS_ELECTIONS_2026 = new Set([
  'AL','AZ','AR','CA','CO','CT','GA','ID','IL','IN','IA','KS','MA','MI','MN','NE',
  'NV','NM','ND','OH','RI','SC','SD','VT','WI','WY'
]);
const SOS_NO_2026 = {
  KY: { name: 'Michael Adams',    party: 'Republican', nextElection: 'November 2027' },
  LA: { name: 'Nancy Landry',     party: 'Republican', nextElection: 'October 2027' },
  MS: { name: 'Michael Watson',   party: 'Republican', nextElection: 'November 2027' },
  MO: { name: 'Denny Hoskins',    party: 'Republican', nextElection: 'November 2028' },
  MT: { name: 'Christi Jacobsen', party: 'Republican', nextElection: 'November 2028' },
  NC: { name: 'Elaine Marshall',  party: 'Democratic', nextElection: 'November 2028' },
  ND: { name: 'Michael Howe',     party: 'Republican', nextElection: 'November 2026' },
  OR: { name: 'Tobias Read',      party: 'Democratic', nextElection: 'November 2028' },
  UT: { name: 'Deidre Henderson', party: 'Republican', nextElection: 'November 2028' },
  VA: { name: 'Kelly Gee',        party: 'Democratic', nextElection: 'Appointed' },
  WA: { name: 'Steve Hobbs',      party: 'Democratic', nextElection: 'November 2028' },
  WV: { name: 'Kris Warner',      party: 'Republican', nextElection: 'November 2028' },
};
// States where SoS is appointed (governor or legislature) — not elected
const SOS_NOT_ELECTED = new Set(['AK','FL','HI','ME','NH','NJ','NY','OK','PA','TN','TX','MD','DE']);

// ── 2026 AGRICULTURE COMMISSIONER (7 states) ──
const AGRICULTURE_ELECTIONS_2026 = new Set(['AL','FL','GA','IA','ND','SC','TX']);

// ── 2026 INSURANCE COMMISSIONER (4 states) ──
const INSURANCE_ELECTIONS_2026 = new Set(['CA','GA','KS','OK']);

// ── 2026 LABOR COMMISSIONER (2 states on Nov ballot, OR already decided) ──
const LABOR_ELECTIONS_2026 = new Set(['GA','OK']);
const LABOR_DECIDED_2026 = new Set(['OR']);  // OR: already decided in May, not on the November ballot

// ── 2026 LAND COMMISSIONER (4 states) ──
const LAND_ELECTIONS_2026 = new Set(['AR','NM','SD','TX']);

// ── 2026 STATE AUDITOR/COMPTROLLER/CONTROLLER (22 states + OK decided) ──
const AUDITOR_ELECTIONS_2026 = new Set([
  'AL','AR','CA','CT','DE','ID','IL','IN','IA','MD','MA','MN','MO','NE','NV','NM',
  'NY','OH','SC','SD','VT','WY'
]);

// What each state calls this office on its ballot (Lisa's 2026 State Auditor file). Every other state: "State Auditor".
const AUDITOR_TITLES = {
  AL: 'State Auditor', AR: 'State Auditor', CA: 'State Controller',
  CT: 'State Comptroller', DE: 'State Auditor', IA: 'Auditor of State',
  ID: 'State Controller', IL: 'State Comptroller', IN: 'State Comptroller',
  MA: 'Auditor of the Commonwealth', MD: 'State Comptroller', MN: 'State Auditor',
  MO: 'State Auditor', NE: 'Auditor of Public Accounts', NM: 'State Auditor',
  NV: 'State Controller', NY: 'State Comptroller', OH: 'Auditor of State',
  OK: 'State Auditor and Inspector', SC: 'Comptroller General', SD: 'State Auditor',
  VT: 'Auditor of Accounts', WY: 'State Auditor',
};

// ── 2026 STATE SUPERINTENDENT OF SCHOOLS (8 states) ──
const SUPERINTENDENT_ELECTIONS_2026 = new Set(['AZ','CA','GA','ID','ND','OK','SC','WY']);

// ── 2026 STATE LEGISLATURE — from Lisa's 2026_State_House_Elections.xlsx and 2026_State_Senate_Races.xlsx ──
// The voter's own races come from the address lookup on Page 1 (voterData.legislature).
// States with no election this year show these messages instead (House wording is Lisa's, word for word).
const STATE_HOUSE_NO_2026 = {
  LA: 'There is no State House election in Louisiana in 2026. The next one is in November 2027.',
  MS: 'There is no State House election in Mississippi in 2026. The next one is in November 2027.',
  NJ: 'There is no State House election in New Jersey in 2026. The next one is in November 2027.',
  VA: 'There is no State House election in Virginia in 2026. The next one is in November 2027.',
  NE: 'Nebraska has no State House. Its Legislature has only one chamber. See your State Senate race.',
};
const STATE_SENATE_NO_2026 = {
  LA: 'There is no State Senate election in Louisiana in 2026. The next one is in November 2027.',
  MS: 'There is no State Senate election in Mississippi in 2026. The next one is in November 2027.',
  NJ: 'There is no State Senate election in New Jersey in 2026. The next one is in November 2027.',
  VA: 'There is no State Senate election in Virginia in 2026. The next one is in November 2027.',
  KS: 'There is no State Senate election in Kansas in 2026. Kansas senators serve four-year terms; the next election is in November 2028.',
  NM: 'There is no State Senate election in New Mexico in 2026. New Mexico senators serve four-year terms; the next election is in November 2028.',
  SC: 'There is no State Senate election in South Carolina in 2026. South Carolina senators serve four-year terms; the next election is in November 2028.',
};
// What each state calls its lower chamber (Lisa's "chamber term" list)
const STATE_HOUSE_NAME = {
  CA: 'State Assembly', NV: 'State Assembly', NY: 'State Assembly', WI: 'State Assembly',
  MD: 'House of Delegates', WV: 'House of Delegates', VA: 'House of Delegates',
};

// ── 2026 BOARDS & COUNCILS — from Lisa's down-ballot files. Page 2 names are her column B, word for word. ──
// Shown only in the states listed. Massachusetts uses the voter's State Senate district (Council Lookup tab);
// every other race is shown to the whole state, as Lisa asked.
const BOARD_OFFICES_2026 = [
  { type: 'governors-council', title: "Governor's Council", icon: '⚖️', color: 'red', races: {
    MA: [
      { raceId: 'MA-governors-council-1', label: "Massachusetts Governor's Council, District 1", council: '1' },
      { raceId: 'MA-governors-council-2', label: "Massachusetts Governor's Council, District 2", council: '2' },
      { raceId: 'MA-governors-council-3', label: "Massachusetts Governor's Council, District 3", council: '3' },
      { raceId: 'MA-governors-council-4', label: "Massachusetts Governor's Council, District 4", council: '4' },
      { raceId: 'MA-governors-council-5', label: "Massachusetts Governor's Council, District 5", council: '5' },
      { raceId: 'MA-governors-council-6', label: "Massachusetts Governor's Council, District 6", council: '6' },
      { raceId: 'MA-governors-council-7', label: "Massachusetts Governor's Council, District 7", council: '7' },
      { raceId: 'MA-governors-council-8', label: "Massachusetts Governor's Council, District 8", council: '8' },
    ],
  } },
  { type: 'executive-council', title: "Executive Council", icon: '🏛️', color: 'purple', races: {
    NH: [
      { raceId: 'NH-executive-council-1', label: "New Hampshire Executive Council, District 1" },
      { raceId: 'NH-executive-council-2', label: "New Hampshire Executive Council, District 2" },
      { raceId: 'NH-executive-council-3', label: "New Hampshire Executive Council, District 3" },
      { raceId: 'NH-executive-council-4', label: "New Hampshire Executive Council, District 4" },
      { raceId: 'NH-executive-council-5', label: "New Hampshire Executive Council, District 5" },
    ],
  } },
  { type: 'oha-trustee', title: "Office of Hawaiian Affairs", icon: '🌺', color: 'blue', races: {
    HI: [
      { raceId: 'HI-oha-trustee-at-large', label: "Office of Hawaiian Affairs Trustee, At-Large (vote for 3)" },
      { raceId: 'HI-oha-trustee-maui', label: "Office of Hawaiian Affairs Trustee, Maui Resident Seat" },
      { raceId: 'HI-oha-trustee-oahu', label: "Office of Hawaiian Affairs Trustee, Oahu Resident Seat" },
    ],
  } },
  { type: 'board-of-education', title: "State Board of Education", icon: '📚', color: 'purple', races: {
    AL: [
      { raceId: 'AL-board-of-education-2', label: "State Board of Education, Education District 2" },
      { raceId: 'AL-board-of-education-4', label: "State Board of Education, Education District 4" },
      { raceId: 'AL-board-of-education-6', label: "State Board of Education, Education District 6" },
      { raceId: 'AL-board-of-education-8', label: "State Board of Education, Education District 8" },
    ],
    CO: [
      { raceId: 'CO-board-of-education-1', label: "State Board of Education, Congressional District 1" },
      { raceId: 'CO-board-of-education-3', label: "State Board of Education, Congressional District 3" },
      { raceId: 'CO-board-of-education-7', label: "State Board of Education, Congressional District 7" },
    ],
    KS: [
      { raceId: 'KS-board-of-education-1', label: "State Board of Education, Education District 1" },
      { raceId: 'KS-board-of-education-3', label: "State Board of Education, Education District 3" },
      { raceId: 'KS-board-of-education-5', label: "State Board of Education, Education District 5" },
      { raceId: 'KS-board-of-education-7', label: "State Board of Education, Education District 7" },
      { raceId: 'KS-board-of-education-9', label: "State Board of Education, Education District 9" },
    ],
    MI: [
      { raceId: 'MI-board-of-education-at-large', label: "State Board of Education: At-large (statewide)" },
    ],
    NE: [
      { raceId: 'NE-board-of-education-5', label: "State Board of Education, Education District 5" },
      { raceId: 'NE-board-of-education-6', label: "State Board of Education, Education District 6" },
      { raceId: 'NE-board-of-education-7', label: "State Board of Education, Education District 7" },
      { raceId: 'NE-board-of-education-8', label: "State Board of Education, Education District 8" },
    ],
    TX: [
      { raceId: 'TX-board-of-education-2', label: "State Board of Education, Education District 2" },
      { raceId: 'TX-board-of-education-4', label: "State Board of Education, Education District 4" },
      { raceId: 'TX-board-of-education-5', label: "State Board of Education, Education District 5" },
      { raceId: 'TX-board-of-education-6', label: "State Board of Education, Education District 6" },
      { raceId: 'TX-board-of-education-7', label: "State Board of Education, Education District 7" },
      { raceId: 'TX-board-of-education-8', label: "State Board of Education, Education District 8" },
      { raceId: 'TX-board-of-education-9', label: "State Board of Education, Education District 9" },
      { raceId: 'TX-board-of-education-13', label: "State Board of Education, Education District 13" },
      { raceId: 'TX-board-of-education-14', label: "State Board of Education, Education District 14" },
    ],
    UT: [
      { raceId: 'UT-board-of-education-1', label: "State Board of Education, Education District 1" },
      { raceId: 'UT-board-of-education-2', label: "State Board of Education, Education District 2" },
      { raceId: 'UT-board-of-education-4', label: "State Board of Education, Education District 4" },
      { raceId: 'UT-board-of-education-5', label: "State Board of Education, Education District 5" },
      { raceId: 'UT-board-of-education-7', label: "State Board of Education, Education District 7" },
      { raceId: 'UT-board-of-education-8', label: "State Board of Education, Education District 8" },
      { raceId: 'UT-board-of-education-11', label: "State Board of Education, Education District 11" },
      { raceId: 'UT-board-of-education-14', label: "State Board of Education, Education District 14" },
    ],
  } },
  { type: 'university-regents', title: "University Regents", icon: '🎓', color: 'blue', races: {
    CO: [
      { raceId: 'CO-regents-2', label: "University of Colorado Board of Regents, Congressional District 2" },
      { raceId: 'CO-regents-6', label: "University of Colorado Board of Regents, Congressional District 6" },
      { raceId: 'CO-regents-7', label: "University of Colorado Board of Regents, Congressional District 7" },
    ],
    MI: [
      { raceId: 'MI-regents-university-of-michigan', label: "University of Michigan Board of Regents (statewide)" },
      { raceId: 'MI-regents-michigan-state', label: "Michigan State University Board of Trustees (statewide)" },
      { raceId: 'MI-regents-wayne-state', label: "Wayne State University Board of Governors (statewide)" },
    ],
    NE: [
      { raceId: 'NE-regents-1', label: "University of Nebraska Board of Regents, District 1" },
      { raceId: 'NE-regents-2', label: "University of Nebraska Board of Regents, District 2" },
      { raceId: 'NE-regents-4', label: "University of Nebraska Board of Regents, District 4 (special election)" },
    ],
    NV: [
      { raceId: 'NV-regents-2', label: "Nevada System of Higher Education Board of Regents, District 2" },
      { raceId: 'NV-regents-3', label: "Nevada System of Higher Education Board of Regents, District 3" },
      { raceId: 'NV-regents-5', label: "Nevada System of Higher Education Board of Regents, District 5" },
      { raceId: 'NV-regents-8', label: "Nevada System of Higher Education Board of Regents, District 8 (special election)" },
      { raceId: 'NV-regents-10', label: "Nevada System of Higher Education Board of Regents, District 10" },
    ],
  } },
  // ── Lisa's Public Service Commission file: 9 states, one button per seat. The group name is what each state calls it. ──
  // Louisiana and Montana seats use PSC districts (their own maps), so — as Lisa asked — everyone in the state sees them;
  // the seat's note on Page 3 says who votes in it.
  { type: 'public-service-commission', title: 'Public Service Commission', icon: '⚡', color: 'blue',
    titleByState: { AZ: 'Corporation Commission', OK: 'Corporation Commission', SD: 'Public Utilities Commission' }, races: {
    AL: [
      { raceId: 'AL-public-service-commission-1', label: "Public Service Commission, Seat 1" },
      { raceId: 'AL-public-service-commission-2', label: "Public Service Commission, Seat 2" },
    ],
    AZ: [
      { raceId: 'AZ-public-service-commission', label: "Corporation Commission (vote for 2)" },
    ],
    GA: [
      { raceId: 'GA-public-service-commission-1', label: "Public Service Commission, District 3" },
      { raceId: 'GA-public-service-commission-2', label: "Public Service Commission, District 5" },
    ],
    LA: [
      { raceId: 'LA-public-service-commission-1', label: "Public Service Commission, District 1" },
      { raceId: 'LA-public-service-commission-2', label: "Public Service Commission, District 5" },
    ],
    MT: [
      { raceId: 'MT-public-service-commission-1', label: "Public Service Commission, District 1" },
      { raceId: 'MT-public-service-commission-2', label: "Public Service Commission, District 5" },
    ],
    NE: [
      { raceId: 'NE-public-service-commission', label: "Public Service Commission, District 2" },
    ],
    ND: [
      { raceId: 'ND-public-service-commission-1', label: "Public Service Commission, Seat 1 (full six-year term)" },
      { raceId: 'ND-public-service-commission-2', label: "Public Service Commission, Seat 2 (two-year term, filling a vacancy)" },
    ],
    OK: [
      { raceId: 'OK-public-service-commission', label: "Corporation Commission" },
    ],
    SD: [
      { raceId: 'SD-public-service-commission', label: "Public Utilities Commission" },
    ],
  } },
  // ── Lisa's Other Statewide Offices file: each office only in its own state ──
  { type: 'railroad-commission', title: 'Railroad Commission', icon: '🛢️', color: 'red', races: {
    TX: [
      { raceId: 'TX-railroad-commission', label: "Texas Railroad Commission" },
    ],
  } },
  { type: 'mine-inspector', title: 'State Mine Inspector', icon: '⛏️', color: 'purple', races: {
    AZ: [
      { raceId: 'AZ-mine-inspector', label: "Arizona State Mine Inspector" },
    ],
  } },
  { type: 'board-of-equalization', title: 'Board of Equalization', icon: '🧾', color: 'blue', races: {
    CA: [
      { raceId: 'CA-board-of-equalization-1', label: "Board of Equalization, District 1" },
      { raceId: 'CA-board-of-equalization-2', label: "Board of Equalization, District 2" },
      { raceId: 'CA-board-of-equalization-3', label: "Board of Equalization, District 3" },
      { raceId: 'CA-board-of-equalization-4', label: "Board of Equalization, District 4" },
    ],
  } },
];
// North Dakota only, statewide (Lisa: Democratic candidate shows as Democratic-NPL)
const TAX_COMMISSIONER_2026 = { ND: { raceId: 'ND-tax-commissioner', label: "North Dakota Tax Commissioner" } };
// Massachusetts State Senate district (Census SLDU code) → Governor's Council district, from Lisa's Council Lookup tab
const MA_COUNCIL_BY_SENATE_DISTRICT = {
  '25D01': '8', '25D02': '8', '25D03': '8', '25D04': '8', '25D05': '8', '25D06': '7', '25D07': '7', '25D08': '7',
  '25D09': '7', '25D10': '7', '25D11': '5', '25D12': '3', '25D13': '2', '25D14': '2', '25D15': '3', '25D16': '3',
  '25D17': '3', '25D18': '4', '25D19': '5', '25D20': '5', '25D21': '5', '25D22': '5', '25D23': '6', '25D24': '6',
  '25D25': '6', '25D26': '6', '25D27': '6', '25D28': '3', '25D29': '4', '25D30': '4', '25D31': '4', '25D32': '4',
  '25D33': '2', '25D34': '2', '25D35': '2', '25D36': '1', '25D37': '1', '25D38': '1', '25D39': '1', '25D40': '1',
};

// ── 2026 STATE AMENDMENT REFERENDUMS — from Lisa's 2026_Ballot_Measures.xlsx (November 3 only) ──
// Column B short names, one box each. Full details load from DB on Page 3 (raceId "CA-measures").
// States not listed have no November 3 statewide measures — no section, no placeholder.
const MEASURES_2026 = {
  AK: [
    'Ballot Measure 2 - Repeal Ranked-Choice Voting',
    'Ballot Measure 3 - Citizenship Requirement for Voting',
  ],
  AL: [
    'Amendment 1 - Lieutenant Governor Vacancy and Legislative Pay (SB 271)',
    'Amendment 2 - County School System Consolidation (HB 380)',
    'Amendment 3 - Pledge of Allegiance and Student-Led Prayer (HB 511)',
    'Amendment 4 - Broadcast The Star-Spangled Banner in Schools',
  ],
  AR: [
    'Issue 1 - Citizens Only Voting Amendment (HJR 1018)',
    'Issue 2 - Right to Keep and Bear Arms (SJR 11)',
    'Issue 3 - Economic Development Districts (SJR 15)',
    'Issue 4 - $500 Million Water and Pollution Abatement Bonds',
  ],
  AZ: [
    'Proposition 141 - Ban Taxes on Miles Driven',
    'Proposition 142 - Ban DEI and Race-Based Preferences',
    'Proposition 144 - Voter ID and Citizenship Requirement',
    'Proposition 316 - 2% Cap on Local Grocery Taxes',
    'Proposition 317 - Drug Cartels as Terrorist Organizations',
    'Proposition 318 - Biological Sex in Sports and Facilities',
    'Proposition 319 - Ban Traffic Enforcement Cameras',
    'Proposition 320 - 60% of School Budgets on Instruction',
  ],
  CA: [
    'Proposition 1 - Veterans and Affordable Housing Bond',
    'Proposition 2 - Larger Rainy Day Fund',
    'Proposition 3 - Extend High-Income Tax for Schools',
    'Proposition 37 - Loan Program for Middle-Income Homebuyers',
    'Proposition 38 - Immunology Research Bond',
    'Proposition 39 - Voter ID Requirement',
    'Proposition 4 - Allow Public Campaign Financing',
    'Proposition 40 - One-Time Wealth Tax',
    'Proposition 41 - Limits on New State Taxes and Special Tax Audits',
    'Proposition 42 - Ban New Personal Property and Retroactive Taxes',
    'Proposition 43 - Two-Thirds Vote for Local Special Taxes',
    'Proposition 44 - Health Center Spending Requirement',
    'Proposition 45 - Faster Environmental Review',
    'Proposition 5 - Eliminate Successor Election in Recalls',
  ],
  CO: [
    'Amendment 81 - Report Certain Non-Citizens to Federal Authorities',
    'Amendment 82 - Right to Natural Gas',
    'Amendment 83 - Right to Hunt and Fish',
    'Amendment 84 - Voter ID for Mail Ballots',
    'Amendment 85 - Plain Language Ballot Questions',
    'Amendment 86 - Limits on Mid-Decade Redistricting',
    'Amendment 87 - Graduated Income Tax',
    'Proposition 132 - Tougher Fentanyl Penalties',
    'Proposition 133 - Life Sentence for Trafficking a Minor',
    'Proposition 134 - Biological Sex in School Sports',
    'Proposition 135 - Bar Certain Surgeries for Minors',
    'Proposition 136 - Cap the Income Tax Rate',
    'Proposition 137 - Sporting Goods Tax for Conservation',
    'Proposition NN - More Money for Public Schools',
  ],
  FL: [
    'Amendment 1 - Budget Stabilization Fund Increase',
    'Amendment 2 - Farm Equipment Property Tax Exemption',
    'Amendment 3 - Larger Homestead Exemption',
  ],
  GA: [
    'Increase Conservation Use Acreage Limit to 4,000 Acres',
    'Next Generation 9-1-1 Fund (HR 1243)',
    'Nonpartisan Elections for Probate Judges (HR 251)',
  ],
  HI: [
    'More Time for Judicial Confirmations',
    'RISE Bonds for Housing Infrastructure (SB 3219)',
  ],
  IA: [
    'Amendment 1 - Two-Thirds Vote to Raise Income Taxes',
  ],
  ID: [
    'HJR 4 - Legislature Controls Drug Legalization',
    'HJR 6 - English as Official Language',
    'Official State Gun Advisory Question - choose one firearm (not Yes/No)',
    'Proposition 1 - Reproductive Freedom Act',
  ],
  IN: [
    'Public Question 1 - Denying Bail for Serious Offenses',
    'Residency Requirements for City and Town Court Judges',
  ],
  KS: [
    'Citizenship Voting Requirement',
  ],
  KY: [
    'Amendment 1 - Limit the Governor\'s Pardon Power',
  ],
  LA: [
    'Amendment No. 1 - Disabled Veteran Property Tax Exemption',
    'Amendment No. 10 - Tax Exemptions for Rehabilitated Blighted Properties',
    'Amendment No. 2 - Local Property Tax Rates (Millages)',
    'Amendment No. 3 - Post-Conviction Bail for Crimes Against Children',
    'Amendment No. 4 - Governor Term Limits',
    'Amendment No. 5 - State Retirement Debt',
    'Amendment No. 6 - Additional Property Tax Exemption for Seniors',
    'Amendment No. 7 - Drinking Water Service Lines',
    'Amendment No. 8 - Property and Foreign Adversaries',
    'Amendment No. 9 - Income Limit for Senior Property Tax Assessment Freeze',
  ],
  MA: [
    'Question 1 - Public Records Law',
    'Question 2 - Public Defender Unions',
    'Question 3 - End Party Primaries',
    'Question 4 - Election Day Registration',
    'Question 5 - State Revenue Limit and Rebate',
    'Question 6 - Natural Resource Conservation Fund',
    'Question 7 - Single-Family Homes on Small Lots',
    'Question 8 - Ban Retail Marijuana Sales',
    'Question 9 - 2024 Gun Law Referendum',
  ],
  MD: [
    'Question 1 - Arbitration Reform for State Employees',
    'Question 2 - Temporary Appointments on the Commission on Judicial Disabilities',
    'Question 3 - Congressional Redistricting',
  ],
  MI: [
    'Proposal 2 - Ban Campaign Contributions by Utilities and Large Contractors',
    'Proposal 2026-01 - Constitutional Convention Question',
  ],
  MN: [
    'Permanent School Fund Management',
  ],
  MO: [
    'Amendment 3 - Prohibit Abortion and Gender Transition Care for Minors',
    'Amendment 6 - Protect Citizen Initiatives',
    'Amendment 7 - State Investment Fund',
    'Amendment 8 - Elect County Sheriffs',
    'Proposition A - Congressional Map Referendum',
  ],
  MT: [
    'CI-132 (Ballot Issue #5) - Nonpartisan Judicial Elections',
    'CI-133 (Ballot Issue #8) - Protect the Initiative and Referendum Power',
    'I-194 (Ballot Issue #10) - Limit Political Spending by Artificial Persons',
  ],
  NC: [
    'Limit Local Property Tax Increases (House Bill 1089)',
    'Lower the Income Tax Cap to 3.5% (Senate Bill 1080)',
    'Photo ID for All Voters',
  ],
  ND: [
    'Constitutional Measure 1 - 60% Vote for Constitutional Amendments',
    'Constitutional Measure 2 - Free School Meals',
  ],
  NE: [
    'Initiative Measure 440 - Online Sports Wagering Authorization',
    'Initiative Measure 441 - Online Sports Wagering Regulation',
    'Initiative Measure 442 - Sex-Separate Athletics (Fairness for Girls)',
    'LR19CA - Three-Term Legislative Limit',
  ],
  NH: [
    'Question 1 - Repeal the Register of Probate (CACR 13)',
  ],
  NM: [
    '$20 Million Library Bonds',
    '$230 Million Higher Education Bonds',
    '$30 Million Senior Facility Bonds',
    'End the Governor\'s Pocket Veto',
    'Modernize Qualified Elector Language and School District Ballot Questions',
    'Nominating Committees for University Regents',
    'Pay State Legislators a Salary',
  ],
  NV: [
    'Question 6 - Right to Abortion Before Viability',
    'Question 7 - Voter ID Requirement',
  ],
  OH: [
    'Issue 3 - Voter ID Amendment',
  ],
  OK: [
    'State Question 845 - Judicial Nominating Commission',
    'State Question 847 - Limit Property Value Increases',
  ],
  RI: [
    'Question 1 - $100 Million Economic and Infrastructure Development Bonds',
    'Question 2 - $55 Million Environment and Watershed Bonds',
    'Question 3 - $275 Million Higher Education Facilities Bonds',
    'Question 4 - $50 Million Historical Center and Cultural Grants Bonds',
    'Question 5 - $120 Million Housing and Development Bonds',
  ],
  SD: [
    'Amendment I - Tie Medicaid Expansion to Federal Funding',
    'Amendment J - Citizenship Voting Requirement',
    'Amendment K - Unclaimed Property Trust Fund',
    'Amendment L - 60% Vote for Constitutional Amendments',
  ],
  TN: [
    'Amendment 1 - Remove Right to Bail for Certain Offenses',
    'Amendment 2 - Prohibit State Property Taxes',
    'Amendment 3 - Marsy\'s Law Crime Victims Rights',
  ],
  UT: [
    '60% Vote for Tax-Raising Initiatives (SJR 2)',
    'Publication Requirements for Amendments (HJR 10)',
  ],
  VA: [
    'Question 1 - Right to Reproductive Freedom',
    'Question 2 - Marriage',
    'Question 3 - Right to Vote',
  ],
  VT: [
    'Proposal 3 - Right to Organize a Union',
    'Proposal 4 - Equal Protection of Law',
  ],
  WA: [
    'Initiative IL26-001 - Parental Rights in Schools',
    'Initiative IL26-638 - Fairness in Girls Sports',
    'Initiative IP26-645 - Repeal the State Income Tax',
  ],
  WI: [
    'Question 1 - Limit the Partial Veto',
    'Question 2 - Freedom to Gather in Places of Worship',
    'Question 3 - Ban Government Preferential Treatment',
  ],
  WV: [
    'Citizenship Voting Requirement',
  ],
  WY: [
    'Homeowner Primary Residence Property Tax Exemption',
  ],
};


// ── No-election panel — reusable across all race types ──
function NoElectionPanel({ type, state, stateName, note }) {
  const [expanded, setExpanded] = useState(false);

  // State Senate / State House panel — message is passed in (no election, district not up, or lookup failed)
  if (type === 'state-senate' || type === 'state-house') {
    const isSenate = type === 'state-senate';
    return (
      <div className={`race-btn race-btn--${isSenate ? 'purple' : 'blue'} race-btn--unavailable`}>
        <span className="race-btn-icon">{isSenate ? '🏛️' : '🏠'}</span>
        <div className="unavailable-content">
          <div className="unavailable-title">{isSenate ? 'State Senate' : (STATE_HOUSE_NAME[state] || 'State House')}</div>
          <div className="unavailable-note">{note}</div>
        </div>
      </div>
    );
  }

  // Governor panel
  if (type === 'governor') {
    const info = GOVERNOR_NO_2026[state];
    if (!info) return null;
    return (
      <div className="race-btn race-btn--purple race-btn--unavailable">
        <span className="race-btn-icon">🗳️</span>
        <div className="unavailable-content">
          <div className="unavailable-title">Governor</div>
          <div className="unavailable-note">There is no Governor election in {stateName} in November 2026.</div>
          <button className="unavailable-toggle" onClick={() => setExpanded(!expanded)}>
            {expanded ? 'Hide details ▲' : 'See current governor ▼'}
          </button>
          {expanded && (
            <div className="unavailable-details">
              <div className="unavailable-detail-row">
                <span className="unavailable-label">Current Governor:</span>
                <span className="unavailable-value">{info.name} ({info.party === 'Democratic' ? 'D' : 'R'})</span>
              </div>
              <div className="unavailable-detail-row">
                <span className="unavailable-label">Next Election:</span>
                <span className="unavailable-value">{info.nextElection}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  // Senate panel
  if (type === 'senate') {
    const info = SENATE_NO_2026[state];
    if (!info) return null;
    return (
      <div className="race-btn race-btn--red race-btn--unavailable">
        <span className="race-btn-icon">⭐</span>
        <div className="unavailable-content">
          <div className="unavailable-title">U.S. Senate</div>
          <div className="unavailable-note">There is no U.S. Senate election in {stateName} in November 2026.</div>
          <button className="unavailable-toggle" onClick={() => setExpanded(!expanded)}>
            {expanded ? 'Hide details ▲' : 'See current senators ▼'}
          </button>
          {expanded && (
            <div className="unavailable-details">
              {info.senators.map((s, i) => (
                <div key={i} className="unavailable-detail-row">
                  <span className="unavailable-label">Senator:</span>
                  <span className="unavailable-value">{s.name} ({s.party === 'Democratic' ? 'D' : s.party === 'Independent' ? 'I' : 'R'})</span>
                </div>
              ))}
              <div className="unavailable-detail-row">
                <span className="unavailable-label">Next Elections:</span>
                <span className="unavailable-value">{info.nextElection}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  // Lieutenant Governor panel
  if (type === 'lieutenant-governor') {
    if (LTGOV_NO_OFFICE.has(state)) {
      return (
        <div className="race-btn race-btn--purple race-btn--unavailable">
          <span className="race-btn-icon">👥</span>
          <div className="unavailable-content">
            <div className="unavailable-title">Lieutenant Governor</div>
            <div className="unavailable-note">{stateName} does not have a Lieutenant Governor.</div>
          </div>
        </div>
      );
    }
    const info = LTGOV_NO_2026[state];
    return (
      <div className="race-btn race-btn--purple race-btn--unavailable">
        <span className="race-btn-icon">👥</span>
        <div className="unavailable-content">
          <div className="unavailable-title">Lieutenant Governor</div>
          <div className="unavailable-note">There is no Lieutenant Governor election in {stateName} in November 2026.</div>
          {info && (
            <>
              <button className="unavailable-toggle" onClick={() => setExpanded(!expanded)}>
                {expanded ? 'Hide details ▲' : 'See current lieutenant governor ▼'}
              </button>
              {expanded && (
                <div className="unavailable-details">
                  <div className="unavailable-detail-row">
                    <span className="unavailable-label">Current:</span>
                    <span className="unavailable-value">{info.name} ({info.party === 'Democratic' ? 'D' : 'R'})</span>
                  </div>
                  <div className="unavailable-detail-row">
                    <span className="unavailable-label">Next Election:</span>
                    <span className="unavailable-value">{info.nextElection}</span>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  }

  // Attorney General panel
  if (type === 'attorney-general') {
    if (AG_NOT_ELECTED.has(state)) {
      return (
        <div className="race-btn race-btn--red race-btn--unavailable">
          <span className="race-btn-icon">⚖️</span>
          <div className="unavailable-content">
            <div className="unavailable-title">Attorney General</div>
            <div className="unavailable-note">The {stateName} Attorney General is not elected by voters.</div>
          </div>
        </div>
      );
    }
    const info = AG_NO_2026[state];
    return (
      <div className="race-btn race-btn--red race-btn--unavailable">
        <span className="race-btn-icon">⚖️</span>
        <div className="unavailable-content">
          <div className="unavailable-title">Attorney General</div>
          <div className="unavailable-note">There is no Attorney General election in {stateName} in November 2026.</div>
          {info && (
            <>
              <button className="unavailable-toggle" onClick={() => setExpanded(!expanded)}>
                {expanded ? 'Hide details ▲' : 'See current attorney general ▼'}
              </button>
              {expanded && (
                <div className="unavailable-details">
                  <div className="unavailable-detail-row">
                    <span className="unavailable-label">Current:</span>
                    <span className="unavailable-value">{info.name} ({info.party === 'Democratic' ? 'D' : 'R'})</span>
                  </div>
                  <div className="unavailable-detail-row">
                    <span className="unavailable-label">Next Election:</span>
                    <span className="unavailable-value">{info.nextElection}</span>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  }

  // Treasurer panel
  if (type === 'treasurer') {
    if (TREASURER_NO_OFFICE.has(state)) {
      return (
        <div className="race-btn race-btn--blue race-btn--unavailable">
          <span className="race-btn-icon">💰</span>
          <div className="unavailable-content">
            <div className="unavailable-title">State Treasurer</div>
            <div className="unavailable-note">{stateName} does not have an elected State Treasurer.</div>
          </div>
        </div>
      );
    }
    const info = TREASURER_NO_2026[state];
    return (
      <div className="race-btn race-btn--blue race-btn--unavailable">
        <span className="race-btn-icon">💰</span>
        <div className="unavailable-content">
          <div className="unavailable-title">State Treasurer</div>
          <div className="unavailable-note">There is no State Treasurer election in {stateName} in November 2026.</div>
          {info && (
            <>
              <button className="unavailable-toggle" onClick={() => setExpanded(!expanded)}>
                {expanded ? 'Hide details ▲' : 'See current state treasurer ▼'}
              </button>
              {expanded && (
                <div className="unavailable-details">
                  <div className="unavailable-detail-row">
                    <span className="unavailable-label">Current:</span>
                    <span className="unavailable-value">{info.name} ({info.party === 'Democratic' ? 'D' : info.party === 'Republican' ? 'R' : '—'})</span>
                  </div>
                  <div className="unavailable-detail-row">
                    <span className="unavailable-label">Next Election:</span>
                    <span className="unavailable-value">{info.nextElection}</span>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  }

  // Secretary of State panel
  if (type === 'secretary-of-state') {
    if (SOS_NOT_ELECTED.has(state)) {
      return (
        <div className="race-btn race-btn--purple race-btn--unavailable">
          <span className="race-btn-icon">📜</span>
          <div className="unavailable-content">
            <div className="unavailable-title">Secretary of State</div>
            <div className="unavailable-note">The {stateName} Secretary of State is not elected by voters.</div>
          </div>
        </div>
      );
    }
    const info = SOS_NO_2026[state];
    return (
      <div className="race-btn race-btn--purple race-btn--unavailable">
        <span className="race-btn-icon">📜</span>
        <div className="unavailable-content">
          <div className="unavailable-title">Secretary of State</div>
          <div className="unavailable-note">There is no Secretary of State election in {stateName} in November 2026.</div>
          {info && (
            <>
              <button className="unavailable-toggle" onClick={() => setExpanded(!expanded)}>
                {expanded ? 'Hide details ▲' : 'See current secretary of state ▼'}
              </button>
              {expanded && (
                <div className="unavailable-details">
                  <div className="unavailable-detail-row">
                    <span className="unavailable-label">Current:</span>
                    <span className="unavailable-value">{info.name} ({info.party === 'Democratic' ? 'D' : 'R'})</span>
                  </div>
                  <div className="unavailable-detail-row">
                    <span className="unavailable-label">Next Election:</span>
                    <span className="unavailable-value">{info.nextElection}</span>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  }

  // ── 6 additional down-ballot offices (Agriculture, Insurance, Labor, Land, Auditor, Superintendent) ──
  // These offices are elected in very few states. Shared handler with per-office labels.
  const downBallotOffices = {
    'agriculture-commissioner': { title: 'Agriculture Commissioner',   icon: '🌾', color: 'purple', officeLabel: 'agriculture commissioner' },
    'insurance-commissioner':   { title: 'Insurance Commissioner',     icon: '🛡️', color: 'red',    officeLabel: 'insurance commissioner' },
    'labor-commissioner':       { title: 'Labor Commissioner',         icon: '👷', color: 'blue',   officeLabel: 'labor commissioner' },
    'land-commissioner':        { title: 'Land Commissioner',          icon: '🗺️', color: 'red',    officeLabel: 'land commissioner' },
    'auditor':                  { title: 'State Auditor',              icon: '📊', color: 'purple', officeLabel: 'state auditor' },
    'superintendent-of-schools': { title: 'Superintendent of Schools', icon: '🎓', color: 'blue',   officeLabel: 'superintendent of schools' },
  };
  if (downBallotOffices[type]) {
    const opts = downBallotOffices[type];
    return (
      <div className={`race-btn race-btn--${opts.color} race-btn--unavailable`}>
        <span className="race-btn-icon">{opts.icon}</span>
        <div className="unavailable-content">
          <div className="unavailable-title">{opts.title}</div>
          <div className="unavailable-note">
            {type === 'labor-commissioner' && state === 'OR'
              ? `Oregon already decided this office in May 2026 — Christina Stephenson (incumbent) won and serves a second four-year term. It is not on your November ballot.`
              : `${stateName} does not hold a ${opts.officeLabel} election in November 2026.`}
          </div>
        </div>
      </div>
    );
  }

  return null;
}


// ── Which states have which 2026 elections ──
const GOVERNOR_2026 = new Set(Object.keys(STATE_NAMES).filter(s => !GOVERNOR_NO_2026[s]));
const SENATE_2026 = new Set(Object.keys(STATE_NAMES).filter(s => !SENATE_NO_2026[s]));


function Page2({ voterData, onRaceSelect, onBack }) {
  const { state, district, zipCode } = voterData;
  const stateName = STATE_NAMES[state] || state;

  const hasGovernor = GOVERNOR_2026.has(state);
  const hasSenate = SENATE_2026.has(state);
  const hasLtGov = LTGOV_ELECTIONS_2026.has(state);
  const hasAG = AG_ELECTIONS_2026.has(state);
  const hasTreasurer = TREASURER_ELECTIONS_2026.has(state);
  const hasSoS = SOS_ELECTIONS_2026.has(state);
  const hasAgriculture = AGRICULTURE_ELECTIONS_2026.has(state);
  const hasInsurance = INSURANCE_ELECTIONS_2026.has(state);
  const hasLabor = LABOR_ELECTIONS_2026.has(state);
  const hasLand = LAND_ELECTIONS_2026.has(state);
  const hasAuditor = AUDITOR_ELECTIONS_2026.has(state);
  const hasSuperintendent = SUPERINTENDENT_ELECTIONS_2026.has(state);
  const stateMeasures = MEASURES_2026[state] || [];
  const hasMeasures = stateMeasures.length > 0;

  // ── State Senate / State House — races for the voter's exact districts (looked up from the address on Page 1) ──
  const legislature = voterData.legislature || null;
  const senateRaces = legislature?.stateSenate || [];
  const houseRaces = legislature?.stateHouse || [];
  const houseName = STATE_HOUSE_NAME[state] || 'State House';
  function legislatureNote(chamber, noElection, districtInfo) {
    if (noElection) return noElection;
    if (!legislature || !legislature.matched) {
      return `We couldn't match your street address to a ${chamber} district. Please go back and check the address.`;
    }
    const where = districtInfo?.name ? `your district (${districtInfo.name})` : 'your district';
    return `There is no ${chamber} election in ${where} in November 2026.`;
  }

  // ── Boards & councils — which of the state's races belong to this voter ──
  function boardRacesFor(office) {
    const list = office.races[state] || [];
    if (office.type === 'governors-council') {
      // Lisa: State Senate district (SLDU) → Council Lookup tab. No address match → show all 8 (her fallback).
      const council = MA_COUNCIL_BY_SENATE_DISTRICT[legislature?.stateSenateDistrict?.geoid];
      return council ? list.filter(r => r.council === council) : list;
    }
    return list;
  }
  // Governor's Council is shown inside Legal & Oversight (Lisa, Oct 23), not as its own group
  const boardOffices = BOARD_OFFICES_2026.filter(o => o.races[state] && o.type !== 'governors-council');
  const governorsCouncil = BOARD_OFFICES_2026.find(o => o.type === 'governors-council' && o.races[state]);
  const taxCommissioner = TAX_COMMISSIONER_2026[state];

  return (
    <div className="page2">
      <div className="page2-hero">
        <div className="page2-overlay" />
        <div className="page2-content fade-in">
          <button className="btn-back" onClick={onBack}>← Back</button>

          <div className="page2-header">
            <p className="page2-district">
              Your {stateName}{district ? ` · ${getOrdinal(district)} Congressional District` : ''} Ballot
            </p>
            <h1 className="page2-title">Select a race to compare<br />the major party candidates.</h1>
            <p className="page2-note">
              We are actively working to expand our database to include your full ballot soon.
            </p>
          </div>

          <div className="page2-buttons page2-groups">

            {/* ── YOUR STATE ELECTION RESOURCES — official state election site, always first ── */}
            {STATE_ELECTION_SITES[state] && (
              <div className="page2-group">
                <h2 className="page2-group-title">Your State Election Resources</h2>
                <p className="page2-resources-note">
                  Use this link to reach your state’s official election site for the most accurate ballot, candidate, and voting information.
                </p>
                <div className="page2-group-buttons">
                  <a
                    className="race-btn race-btn--blue page2-resource-btn"
                    href={STATE_ELECTION_SITES[state]}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="race-btn-icon">🗳️</span>
                    {stateName} Official<br />Election Site ↗
                  </a>
                </div>
              </div>
            )}

            {/* ── FEDERAL OFFICES ── */}
            <div className="page2-group">
              <h2 className="page2-group-title">Federal Offices</h2>
              <div className="page2-group-buttons">
                {/* U.S. House — always available */}
                <button
                  className="race-btn race-btn--blue"
                  onClick={() => onRaceSelect({ type: 'house', state, district, stateName, zipCode })}
                >
                  <span className="race-btn-icon">🏛️</span>
                  U.S. House of<br />Representatives
                </button>

                {/* U.S. Senate */}
                {hasSenate ? (
                  <button
                    className="race-btn race-btn--red"
                    onClick={() => onRaceSelect({ type: 'senate', state, district, stateName, zipCode })}
                  >
                    <span className="race-btn-icon">⭐</span>
                    U.S. Senate
                  </button>
                ) : (
                  <NoElectionPanel type="senate" state={state} stateName={stateName} />
                )}
              </div>
            </div>

            {/* ── STATE EXECUTIVE ── */}
            <div className="page2-group">
              <h2 className="page2-group-title">State Executive</h2>
              <div className="page2-group-buttons">
                {hasGovernor ? (
                  <button
                    className="race-btn race-btn--purple"
                    onClick={() => onRaceSelect({ type: 'governor', state, district, stateName, zipCode })}
                  >
                    <span className="race-btn-icon">🗳️</span>
                    Governor
                  </button>
                ) : (
                  <NoElectionPanel type="governor" state={state} stateName={stateName} />
                )}

                {hasLtGov ? (
                  <button
                    className="race-btn race-btn--purple"
                    onClick={() => onRaceSelect({ type: 'lieutenant-governor', state, district, stateName, zipCode })}
                  >
                    <span className="race-btn-icon">👥</span>
                    Lieutenant<br />Governor
                  </button>
                ) : (
                  <NoElectionPanel type="lieutenant-governor" state={state} stateName={stateName} />
                )}
              </div>
            </div>

            {/* ── LEGAL & OVERSIGHT ── */}
            <div className="page2-group">
              <h2 className="page2-group-title">Legal &amp; Oversight</h2>
              <div className="page2-group-buttons">
                {hasAG ? (
                  <button
                    className="race-btn race-btn--red"
                    onClick={() => onRaceSelect({ type: 'attorney-general', state, district, stateName, zipCode })}
                  >
                    <span className="race-btn-icon">⚖️</span>
                    Attorney<br />General
                  </button>
                ) : (
                  <NoElectionPanel type="attorney-general" state={state} stateName={stateName} />
                )}

                {/* Massachusetts Governor's Council — the voter's own district (all 8 if the address did not match) */}
                {governorsCouncil && boardRacesFor(governorsCouncil).map(r => (
                  <button
                    key={r.raceId}
                    className={`race-btn race-btn--${governorsCouncil.color}`}
                    onClick={() => onRaceSelect({ type: governorsCouncil.type, state, district, stateName, zipCode, raceId: r.raceId, raceLabel: r.label })}
                  >
                    <span className="race-btn-icon">{governorsCouncil.icon}</span>
                    {r.label}
                  </button>
                ))}
              </div>
            </div>

            {/* ── FINANCIAL ── */}
            <div className="page2-group">
              <h2 className="page2-group-title">Financial</h2>
              <div className="page2-group-buttons">
                {hasTreasurer ? (
                  <button
                    className="race-btn race-btn--blue"
                    onClick={() => onRaceSelect({ type: 'treasurer', state, district, stateName, zipCode })}
                  >
                    <span className="race-btn-icon">💰</span>
                    State<br />Treasurer
                  </button>
                ) : (
                  <NoElectionPanel type="treasurer" state={state} stateName={stateName} />
                )}

                {/* State Auditor / Comptroller is a financial office (moved from Legal & Oversight) */}
                {hasAuditor && (
                  <button
                    className="race-btn race-btn--purple"
                    onClick={() => onRaceSelect({ type: 'auditor', state, district, stateName, zipCode })}
                  >
                    <span className="race-btn-icon">📊</span>
                    {(() => { const t = AUDITOR_TITLES[state] || 'State Auditor'; const i = t.lastIndexOf(' '); return <>{t.slice(0, i)}<br />{t.slice(i + 1)}</>; })()}
                  </button>
                )}

                {hasInsurance && (
                  <button
                    className="race-btn race-btn--red"
                    onClick={() => onRaceSelect({ type: 'insurance-commissioner', state, district, stateName, zipCode })}
                  >
                    <span className="race-btn-icon">🛡️</span>
                    Insurance<br />Commissioner
                  </button>
                )}

                {/* North Dakota only */}
                {taxCommissioner && (
                  <button
                    className="race-btn race-btn--blue"
                    onClick={() => onRaceSelect({ type: 'tax-commissioner', state, district, stateName, zipCode, raceId: taxCommissioner.raceId, raceLabel: taxCommissioner.label })}
                  >
                    <span className="race-btn-icon">🧾</span>
                    Tax<br />Commissioner
                  </button>
                )}
              </div>
            </div>

            {/* ── ELECTIONS & RECORDS ── */}
            <div className="page2-group">
              <h2 className="page2-group-title">Elections &amp; Records</h2>
              <div className="page2-group-buttons">
                {hasSoS ? (
                  <button
                    className="race-btn race-btn--purple"
                    onClick={() => onRaceSelect({ type: 'secretary-of-state', state, district, stateName, zipCode })}
                  >
                    <span className="race-btn-icon">📜</span>
                    Secretary<br />of State
                  </button>
                ) : (
                  <NoElectionPanel type="secretary-of-state" state={state} stateName={stateName} />
                )}
              </div>
            </div>

            {/* ── DEPARTMENT HEADS — only when the state elects at least one of these this November ── */}
            {(hasAgriculture || hasLabor || hasLand || hasSuperintendent) && (
            <div className="page2-group">
              <h2 className="page2-group-title">Department Heads</h2>
              <div className="page2-group-buttons">
                {hasAgriculture && (
                  <button
                    className="race-btn race-btn--purple"
                    onClick={() => onRaceSelect({ type: 'agriculture-commissioner', state, district, stateName, zipCode })}
                  >
                    <span className="race-btn-icon">🌾</span>
                    Agriculture<br />Commissioner
                  </button>
                )}

                {hasLabor && (
                  <button
                    className="race-btn race-btn--blue"
                    onClick={() => onRaceSelect({ type: 'labor-commissioner', state, district, stateName, zipCode })}
                  >
                    <span className="race-btn-icon">👷</span>
                    Labor<br />Commissioner
                  </button>
                )}

                {hasLand && (
                  <button
                    className="race-btn race-btn--red"
                    onClick={() => onRaceSelect({ type: 'land-commissioner', state, district, stateName, zipCode })}
                  >
                    <span className="race-btn-icon">🗺️</span>
                    Land<br />Commissioner
                  </button>
                )}

                {hasSuperintendent && (
                  <button
                    className="race-btn race-btn--blue"
                    onClick={() => onRaceSelect({ type: 'superintendent-of-schools', state, district, stateName, zipCode })}
                  >
                    <span className="race-btn-icon">🎓</span>
                    Superintendent<br />of Schools
                  </button>
                )}
              </div>
            </div>
            )}

            {/* ── BOARDS & COUNCILS — only in the states that elect them ── */}
            {boardOffices.map(office => {
              const myRaces = boardRacesFor(office);
              return (
                <div className="page2-group" key={office.type}>
                  <h2 className="page2-group-title">{office.titleByState?.[state] || office.title}</h2>
                  <div className="page2-group-buttons">
                    {myRaces.map(r => (
                        <button
                          key={r.raceId}
                          className={`race-btn race-btn--${office.color}`}
                          onClick={() => onRaceSelect({ type: office.type, state, district, stateName, zipCode, raceId: r.raceId, raceLabel: r.label })}
                        >
                          <span className="race-btn-icon">{office.icon}</span>
                          {r.label}
                        </button>
                    ))}
                  </div>
                </div>
              );
            })}

            {/* ── STATE LEGISLATURE — the voter's own State Senate and State House races ── */}
            <div className="page2-group">
              <h2 className="page2-group-title">State Legislature</h2>
              <div className="page2-group-buttons">
                {!STATE_SENATE_NO_2026[state] && senateRaces.length > 0 ? (
                  senateRaces.map(r => (
                    <button
                      key={r.raceId}
                      className="race-btn race-btn--purple"
                      onClick={() => onRaceSelect({ type: 'state-senate', state, district, stateName, zipCode, raceId: r.raceId, raceLabel: r.label })}
                    >
                      <span className="race-btn-icon">🏛️</span>
                      {r.label}
                    </button>
                  ))
                ) : (
                  <NoElectionPanel type="state-senate" state={state} stateName={stateName}
                    note={legislatureNote('State Senate', STATE_SENATE_NO_2026[state], legislature?.stateSenateDistrict)} />
                )}

                {!STATE_HOUSE_NO_2026[state] && houseRaces.length > 0 ? (
                  houseRaces.map(r => (
                    <button
                      key={r.raceId}
                      className="race-btn race-btn--blue"
                      onClick={() => onRaceSelect({ type: 'state-house', state, district, stateName, zipCode, raceId: r.raceId, raceLabel: r.label })}
                    >
                      <span className="race-btn-icon">🏠</span>
                      {r.label}
                    </button>
                  ))
                ) : (
                  <NoElectionPanel type="state-house" state={state} stateName={stateName}
                    note={legislatureNote(houseName, STATE_HOUSE_NO_2026[state], legislature?.stateHouseDistrict)} />
                )}
              </div>
            </div>

            {/* ── STATE AMENDMENT REFERENDUMS — only in states with November 3 statewide measures ── */}
            {hasMeasures && (
              <div className="page2-group">
                <h2 className="page2-group-title">State Amendment Referendums</h2>
                <div className="page2-group-buttons">
                  {stateMeasures.map(name => (
                    <button
                      key={name}
                      className="race-btn race-btn--blue"
                      onClick={() => onRaceSelect({ type: 'measures', state, district, stateName, zipCode, focusMeasure: name })}
                    >
                      <span className="race-btn-icon">📝</span>
                      {name}
                    </button>
                  ))}
                </div>
              </div>
            )}

          </div>

          <div style={{
            maxWidth: '900px',
            margin: '20px auto 24px',
            padding: '0 20px',
            textAlign: 'center',
            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
            fontSize: '12px',
            lineHeight: '1.5',
            color: 'rgba(255, 255, 255, 0.55)'
          }}>
            <div>
              <strong style={{ color: 'rgba(255,255,255,0.75)' }}>Disclaimer:</strong>{' '}
              We work hard to keep candidate information accurate, but always verify with your official state election office.
            </div>
            <div style={{ marginTop: '4px' }}>
              See an error? Email{' '}
              <a href="mailto:corrections@indtimes.news" style={{ color: 'rgba(255, 255, 255, 0.8)', textDecoration: 'underline' }}>corrections@indtimes.news</a>,
              so we can update it promptly.
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Page2;